module.exports = __webpack_public_path__ + "img/portraits_17_V.1db8bb4d.webp";